import { render, staticRenderFns } from "./VAMapMarker.vue?vue&type=template&id=4accc2a9&scoped=true&lang=pug"
import script from "./VAMapMarker.vue?vue&type=script&lang=js"
export * from "./VAMapMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4accc2a9",
  null
  
)

export default component.exports